import { Outlet, useLocation, Navigate } from "react-router-dom";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { tokenExpirado } from "./Components/Funcionais/Utils";
import Header from "./Components/Layout/Header";
import Sidebar from "./Components/Layout/Sidebar";
import SessaoAuth from "./Hooks/SessaoAuth";
import appTheme from "./Components/Layout/ThemeFaroIT";
import WhatsIcon from "./Components/Funcionais/WhatsIcon";

// Largura do sidebar para telas maiores
const drawerWidth = "100%";

function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const isSenhaPage = location.pathname === "/senha";
  const isEnviadoPage = location.pathname === "/enviado";
  const isHomePage = location.pathname === "/";
  const isTermo = location.pathname === "/termo";
  const { sessao } = SessaoAuth();

  const theme = useTheme();
  const isMobile = useMediaQuery(appTheme.breakpoints.down("sm"));

  const expirou = tokenExpirado(sessao?.authToken?.validade);

  if (
    (!sessao?.authToken || expirou) &&
    !isLoginPage &&
    !isSenhaPage &&
    !isEnviadoPage
  ) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  if (!sessao?.datAceite && !isTermo && sessao?.authToken && !expirou && !isLoginPage && !isSenhaPage && !isEnviadoPage) {
    return <Navigate to="/termo" state={{ from: location }} replace />;
  }

  if (isHomePage && sessao?.authToken && !expirou) {
    return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return (
    <ThemeProvider theme={theme}>
      {!isLoginPage && !isSenhaPage && !isEnviadoPage && sessao?.authToken && !isTermo ? (
        <>
          <Header />
          <Box sx={{ display: "flex", height: "100%" }}>
            {/* Sidebar com largura fixa */}
            <Sidebar isMobile={isMobile} />
            {/* Conteúdo principal */}
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: 3,
                marginLeft: { sm: `${drawerWidth}px + 100px` }, // Aplicado somente para telas médias ou maiores
                overflow: "auto",
              }}
            >
              <Outlet />
            </Box>
          </Box>

          <WhatsIcon
            phone={import.meta?.env?.VITE_WHATS_NUMBER || "5515997885717"}
            defaultMessage={
              import.meta?.env?.VITE_WHATS_DEFAULT_MESSAGE ||
              "Olá! Preciso de ajuda do suporte."
            }
            position={{ bottom: 24, right: 24 }}
            hideOnSmallScreens={false}
            // Se quiser usar a cor do Whats, pode setar via sx no componente
          />

        </>
      ) : (
        <Outlet />
      )}
    </ThemeProvider>
  );
}

export default App;
